<template>
  <div style="flex:1;position:relative;">
    <div class="page-header">
      <div class="page-title">反馈</div>
      <div class="btn" @click="showUpload">
        <i class="iconfont iconicon_on_the_left"></i>
        <span>反馈界面</span>
      </div>
    </div>
    <div class="left-box">
      <div class="box-title">
        <i class="iconfont iconic_loubaowubaofankui"></i>
        <span>手机号反馈详情</span>
      </div>
      <div class="info-box">
        <p>您好，本次提交{{detailParams.total}}个号码，其中{{detailParams.cover?detailParams.cover:0}}个手机号画像已处理，感谢您的反馈。</p>
        <p>我们将使用您提供的样本进行溯源，以尽早覆盖该批作恶的手机号，</p>
        <p>您可在反馈界面查看所有{{detailParams.type===1?'漏报':'误报'}}数据后续的覆盖情况，我们会在10个工作日内通过微信群回复您{{detailParams.type===1?'漏报':'误报'}}的处理情况。</p>
      </div>
      <div class="progress-box">
        <div class="progress-wrapper">
          <div class="real-progress" :style="{'width':progressWidth}">
            <div class="progress-dot" v-if="progressWidth != '0%'">
              <img src="../../../assets/img/phoneFeedback/progress-dot.png" alt="">
            </div>
          </div>
        </div>
        <div class="border-text">
          <span>已处理/已反馈：</span>
          <span>{{detailParams.cover?detailParams.cover:0}}/{{detailParams.total}}</span>
        </div>
        <div class="plain-text">
          <span>手机号码类型：</span>
          <span>{{detailParams.type===1?'漏报':'误报'}}</span>
        </div>
      </div>
      <div style="width:99%;">
        <el-table :data="tableData" stripe style="width: 100%" v-loading="loading">
          <el-table-column align="center" prop="phone" label="手机号"></el-table-column>
          <el-table-column
            align="center"
            prop="is_cover"
            :label="detailParams.type===1?'是否覆盖':'是否修正'"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.is_cover?'是':'否' }}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="date_cover"
            :label="detailParams.type===1?'覆盖时间':'修正时间'"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.date_cover?formatDate(new Date(scope.row.date_cover)):'-' }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="process_result" label="手机号研判结果">
            <template slot-scope="scope">
              <span>{{ handleResult(scope.row.process_result) }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- <table width="100%">
        <thead>
          <td>手机号</td>
          <td>{{detailParams.type===1?'是否覆盖':'是否修正'}}</td>
          <td>{{detailParams.type===1?'覆盖时间':'修正时间'}}</td>
          <td>手机号研判结果</td>
        </thead>
        <tbody>
          <tr v-for="(item,index) in tableData" :key="index">
            <td>{{item.phone}}</td>
            <td>{{item.is_cover}}</td>
            <td>{{item.date_cover}}</td>
            <td>{{item.process_result}}</td>
          </tr>
        </tbody>
      </table>-->
      <div class="pagination-box">
        <el-pagination
          layout="prev, pager, next"
          :total="total"
          :current-page="tablePage"
          @current-change="pageChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getPhoneEventDetail } from '@/services/interface'
import { formatDate } from '@/util/common'
export default {
  props: {
    detailParams: {
      type: Object
    }
  },
  data () {
    return {
      tableData: [],
      tablePage: 1,
      total: 0,
      loading: false
    }
  },
  computed: {
    // 计算百分比，处理样式
    progressWidth () {
      return parseInt(this.detailParams.cover / this.detailParams.total * 100) + '%'
    }
  },
  methods: {
    /**
     * 表格字段显示处理
     * @param process_result:0、1、2、3
     */
    formatDate,
    handleResult (processResult) {
      switch (processResult) {
        case 0: {
          return '未处理'
        }
        case 1: {
          return '黑卡'
        }
        case 2: {
          return '真人作弊'
        }
        case 3: {
          return '非作弊手机号'
        }
      }
    },

    /**
     * 切换为反馈上传页面
     */
    showUpload () {
      this.$emit('showUpload')
    },

    /**
     * 表格页码切换
     * @param value: 页码
     */
    pageChange (value) {
      this.tablePage = value
      this.getPhoneEventData()
    },

    /**
     * 获取表格数据
     */
    async getPhoneEventData () {
      const params = {
        page: this.tablePage
      }
      this.loading = true
      const res = await getPhoneEventDetail(this.detailParams.event_id, params).then((res) => {
        return res
      })
      this.loading = false
      this.tableData = res.data.data
      this.total = res.data.total
    }
  },
  watch: {
    // 监听参数，重新获取数据，针对在当前详情页点击右边其他事件详情的时候
    detailParams: {
      handler: function () {
        this.tablePage = 1
        this.getPhoneEventData()
      },
      deep: true
    }
  },
  created () {
    this.getPhoneEventData()
  }
}
</script>

<style scoped>
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 32px;
}
.page-header .page-title {
  width: 40px;
  height: 25px;
  line-height: 25px;
  position: relative;
  font-size: 18px;
  font-weight: 500;
  color: rgba(29, 36, 60, 1);
  letter-spacing: 1px;
}
.page-header .page-title::after {
  content: '';
  position: absolute;
  top: 30px;
  left: 0;
  width: 100%;
  height: 3px;
  background: rgba(0, 61, 146, 1);
  border-radius: 2px;
}
.page-header .btn {
  width: 86px;
  height: 24px;
  border-radius: 3px;
  border: 1px solid rgba(31, 35, 46, 1);
  cursor: pointer;
  text-align: center;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.page-header .btn span {
  font-size: 14px;
  font-weight: 400;
  color: rgba(31, 35, 46, 1);
}
.page-header .btn i {
  margin-left: 3px;
}
.left-box {
  padding: 32px 35px 105px 40px;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  height: calc(100% - 57px);
  position: relative;
}
.box-title {
  position: relative;
  font-size: 14px;
  font-weight: 400;
  color: rgba(59, 60, 64, 1);
  line-height: 18px;
  margin-bottom: 24px;
}
.box-title i {
  color: RGBA(0, 61, 146, 1);
  font-size: 18px;
  position: absolute;
  left: -28px;
}
.info-box {
  margin-bottom: 45px;
}
.info-box p {
  font-size: 12px;
  font-weight: 400;
  color: rgba(59, 60, 64, 1);
  line-height: 24px;
}
.progress-box {
  margin-bottom: 68px;
}
.progress-wrapper {
  height: 6px;
  background: rgba(228, 231, 237, 1);
  border-radius: 3px;
  position: relative;
  margin-bottom: 15px;
}
.progress-wrapper .real-progress {
  height: 6px;
  background: rgba(0, 61, 146, 1);
  border-radius: 3px;
  position: absolute;
  left: 0;
  top: 0;
}
.progress-dot {
  position: absolute;
  right: 0;
  width: 12px;
  height: 12px;
  top: -5px;
}
.progress-dot img {
  width: 100%;
  height: 100%;
}
.border-text {
  padding-bottom: 4px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #eef0f5;
  margin-bottom: 4px;
}
.border-text span {
  font-size: 12px;
  font-weight: 400;
  color: rgba(59, 60, 64, 1);
  line-height: 18px;
}
.plain-text {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  font-weight: 400;
  color: rgba(59, 60, 64, 1);
  line-height: 18px;
}
.pagination-box {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
</style>
